const en = {
  title: 'Customers',
  subtitle: 'Private customers for the repair service',
  addCustomer: '+ Add Customer',
  errorLoading: 'Error loading customers: {{error}}',
  noCustomersTitle: 'No Customers Yet',
  noCustomersMessage: 'Create your first customer to get started',
  email: 'Email',
  phone: 'Phone',
  street: 'Street',
  number: 'Number',
  zip: 'ZIP',
  city: 'City',
  editCustomer: 'Edit Customer',
  createCustomer: 'Create New Customer',
  saveChanges: 'Save Changes',
  deleteCustomer: 'Delete Customer',
  confirmDelete: 'Are you sure you want to delete "{{name}}"?',
};

const de = {
  title: 'Kunden',
  subtitle: 'Privatkunden für den Reparaturservice',
  addCustomer: '+ Kunde hinzufügen',
  errorLoading: 'Fehler beim Laden der Kunden: {{error}}',
  noCustomersTitle: 'Noch keine Kunden',
  noCustomersMessage: 'Erstellen Sie Ihren ersten Kunden, um loszulegen',
  email: 'E-Mail',
  phone: 'Telefon',
  street: 'Straße',
  number: 'Hausnummer',
  zip: 'PLZ',
  city: 'Stadt',
  editCustomer: 'Kunde bearbeiten',
  createCustomer: 'Neuen Kunden erstellen',
  saveChanges: 'Änderungen speichern',
  deleteCustomer: 'Kunde löschen',
  confirmDelete: 'Möchten Sie „{{name}}" wirklich löschen?',
};

const customers = { en, de };
export default customers;
